import {getOneHeadUrlById} from "../../config/UserHeadConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import O1HD from "../../../../engines/gameEngine";
import {getOneWeChatTriggerTimeLinkById} from "../../config/WeChatTriggerTimeLinkConfig";
import {getOneChitAryById} from "../../config/WeChatChitChatConfig";
import WeChatFrame from "./WeChatFrame";
import WeChatHousePrefab from "./WeChatHousePrefab";

const {ccclass, property} = cc._decorator;

/**
 * 朋友圈
 */
@ccclass
export default class PyqNode extends cc.Component {

    @property(cc.Label)
    lbUserName: cc.Label = null;
    @property({type:cc.Sprite,displayName:"头像"})
    headSpirit : cc.Sprite = null;

    @property(cc.Prefab)
    chatFramePrefab : cc.Prefab = null;
    @property(WeChatHousePrefab)
    weChatHouseNode : WeChatHousePrefab = null;

    private mGameLayer : NormalGameManager;

    onLoad () {
        this.mGameLayer = NormalGameManager._instance;
    }

    start () {
        //加载头像
        let headUrl = getOneHeadUrlById(NormalGameManager._instance.getGameData().userCurrHead);
        O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`res/user/head/${headUrl}`,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.log(err);
            }else{
                this.headSpirit.getComponent(cc.Sprite).spriteFrame = spr;
            }
        });
    }

    /**
     * 联系
     */
    onBtnContact( e , define : string ){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let uniqueId = "21";
        switch ( define ) {
            case "0":
                break;
            case "1":
                uniqueId = "20";
                break;
            case "2":
                uniqueId = "24";
                break;
        }
        let streetInfoArray = this.mGameLayer.getGameData().streetInfo;
        if ( streetInfoArray && streetInfoArray.includes(uniqueId) ) {
            O1HD.getModules().uiControlModule.showMessageBox("已经建立联系了");
            return;
        }


        let weChatLink = uniqueId;
        if(weChatLink!=null){
            //添加一个微信聊天 触发
            let isTrue = this.mGameLayer.addOneWeChatTriggerLink(weChatLink);
            if(!isTrue){   
            this.weChatHouseNode.closeThis();
                return;
            }
            this.mGameLayer.mGameLayer.onBtnOpenPrefab(null,"weChat");
            //聊天链
            let link = getOneWeChatTriggerTimeLinkById(weChatLink);
            //聊天链的初始端
            let chitChat = getOneChitAryById(link.link[0].id);
            //聊天对象 信息
            let people = this.mGameLayer.weChatManager.getOnePeopleById(chitChat.people);
            //聊天对象的队列
            let chitChatQueue = people.peopleChatLinkQueue;
            let chatFrame = cc.instantiate( this.chatFramePrefab );
            let cs = chatFrame.getComponent( WeChatFrame );
            if( chitChatQueue.length >0 ){
                // let chitChat = getOneChitAryById(chitChatQueue[0]);
                cs.bindData( chitChatQueue[0],[] , people , this.closeThis.bind(this));
            }
            O1HD.Canvas().addChild(chatFrame);
        }
        if ( streetInfoArray ) {
            streetInfoArray.push(`${uniqueId}`);
        }else{
            streetInfoArray = [`${uniqueId}`];
        }
        this.mGameLayer.setGameData({ streetInfo: streetInfoArray} ,false );
        this.weChatHouseNode.closeThis();
    }


    /**
     * 完成回调
     */
    closeThis(){

    }
}
